import React from "react";

import { useAppStore } from "@store/appStateStore";

// TransactionReportButton - кнопка для выгрузки CSV-отчёта по транзакциям.
const TransactionReportButton: React.FC = () => {
  const { transactions, participants } = useAppStore();

  const handleExportCSV = () => {
    // Создаём карту participant_id -> name для быстрого поиска
    const participantMap = new Map<number, string>();
    participants.forEach((p) => participantMap.set(p.id, p.name));

    // Сортируем транзакции по дате (по возрастанию)
    const sortedTransactions = [...transactions].sort(
      (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime(),
    );

    // Формируем строки CSV
    const rows = sortedTransactions.map((t) => {
      // Форматируем дату из ISO (yyyy-mm-dd) в dd.mm.yyyy
      const date = t.date.split("-").reverse().join(".");
      const name = participantMap.get(t.participant_id) || "Неизвестно";
      const amount = t.amount;

      return `${date},${name},${amount}`;
    });

    // Собираем весь CSV-контент
    const csvContent = [
      "Дата транзакции,Имя посещающего,Сумма транзакции",
      ...rows,
    ].join("\n");

    // Создаём и скачиваем файл
    const blob = new Blob([csvContent], {
      type: "text/csv;charset=utf-8;header=present",
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "transactions_report.csv";
    link.click();

    URL.revokeObjectURL(url);
  };

  return (
    <button type="button" className="control" onClick={handleExportCSV}>
      Скачать CSV-отчёт
    </button>
  );
};

export default TransactionReportButton;
